import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/build/css/mdb.css';
// import 'mdbvue/lib/css/mdb.min.css';
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import store from './store'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
